import styles from './processing-status.module.css';
import { useTranslations } from 'i18n';
import { IconLoader, Text } from 'ui';
import { AthletesGrid } from './athletes-grid';
import { type AthleteStatusGroups } from './hooks/useAthleteStatusGroups';
import { ActivityAthlete } from 'oas';

type AthletesStatusHeaderAlertProps = {
    message: string;
    guidance: string;
};

const AthleteStatusHeaderAlert = ({ message, guidance }: AthletesStatusHeaderAlertProps) => {
    return (
        <div className={`${styles['athletes-header-alert-wrapper']}`}>
            <div className={styles['athletes-header-row']}>
                <div className={`${styles['athletes-grid-header-cell-row']} flex-1`}>
                    <IconLoader iconName="IconErrorWarning" size="sm" className="fill-system-error" />
                    <Text className="text-system-primary" variant="title-small">
                        {message}
                    </Text>
                </div>
            </div>
            <div className={styles['athletes-header-row']}>
                <div className={`${styles['athletes-grid-header-cell-row']} flex-1`}>
                    <Text className="text-system-primary" variant="body-small">
                        {guidance}
                    </Text>
                </div>
            </div>
        </div>
    );
};

type AthletesStatusRowProps = {
    activityAthletes: ActivityAthlete[];
    groups: AthleteStatusGroups;
    showMissing: boolean;
    showAll: boolean;
    testId: string;
};

export const AthletesStatusRow: React.FC<AthletesStatusRowProps> = (props) => {
    const { activityAthletes, groups, showMissing, showAll, testId } = props;
    const { __ } = useTranslations();

    if (!showMissing && !showAll) {
        return null;
    }

    return (
        <div className={`${styles['content-column']} ${styles['athletes-header']}`} data-testid={testId}>
            <AthleteStatusHeaderAlert
                message={__('data_processing.athletes_with_missing_raw_files')}
                guidance={__('data_processing.upload_raw_files_to_report')}
            />
            <AthletesGrid
                label={__('data_processing.missing_athletes')}
                athletes={showMissing ? groups.missing : activityAthletes}
            />
        </div>
    );
};
